import {useEffect,useRef,type ReactNode} from 'react'

export function ResidentTicketDialog({title,onClose,children}:{title:string;onClose:()=>void;children:ReactNode}) {
  const dialog=useRef<HTMLDialogElement>(null)
  useEffect(()=>{dialog.current?.showModal();return()=>dialog.current?.close()},[])
  return <dialog ref={dialog} className="resident-ticket-dialog" onCancel={e=>{e.preventDefault();onClose()}} aria-labelledby="resident-ticket-title">
    <header className="resident-ticket-header"><span className="resident-ticket-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M12 3 2 20h20L12 3Zm0 6v5m0 3v1"/></svg></span><div><h2 id="resident-ticket-title">{title}</h2><p>Envie para a administração do condomínio</p></div><button type="button" onClick={onClose} aria-label="Fechar formulário">×</button></header>
    {children}
  </dialog>
}
